document.addEventListener('DOMContentLoaded',function() {

    const cover = document.getElementById('cover');
    
    const init = function() {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
        
        setTimeout(function() {
            
            window.animsInit();
            document.getElementsByClassName('js-reviewsSlider')[0] ? window.reviews() : false;            
            
            cover.remove();
            
            window.location.hash ? window.runScroll( '#'+document.getElementById(window.location.hash.substring(1)).id ) : false;
        }, 250); 
        
        
        const customCheckboxes = function() {
            const cf_checkbox = document.getElementsByClassName('wpcf7-checkbox');            

            for (let i = 0; i < cf_checkbox.length; i++) {
                
                const icon = document.createElement("i");

                let label = cf_checkbox[i].getElementsByTagName('label')[0];
                let input = label.getElementsByTagName('input')[0];
                let span = cf_checkbox[i].getElementsByClassName('wpcf7-list-item-label')[0];
                let id = cf_checkbox[i].getAttribute('id');
                let parentDiv = label.parentNode;
    
                input.setAttribute('id', id);
     
                label.setAttribute('for', id);
                label.removeChild(input);
                label.insertBefore(icon, span);
     
                parentDiv.insertBefore(input, label);
                
                cf_checkbox[i].removeAttribute('id');
            }  
        }
        
        customCheckboxes();
              
    };
    
    window.addEventListener('load', init);

}, false);